import { styled } from 'styled-components';

export const Page = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.grey00_1};
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
`;

export const IconWrapper = styled.div<{ $variant: 'success' | 'warning' }>`
  display: flex;
  margin-bottom: 4px;
  color: ${({ theme, $variant }) => ($variant === 'success' ? theme.colors.positive100 : theme.colors.warning100)};
`;
